import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface Iprop {
  size?: string | number;
}

export default function CircularIndeterminate({ size }: Iprop) {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress size={size ?? "30px"} />
    </Box>
  );
}
